const PRIVACY_URL = "https://legendsportscave.com/privacy/";
const TERMS_URL = "https://legendsportscave.com/ticket-holder-agreement/";

/** Shared public legal links and DMCA notice for the apex and Cave storefronts. */
export default function PublicLegalFooter() {
  return (
    <div
      style={{
        width: "100%",
        borderTop: "1px solid var(--hairline, var(--border-mute))",
        paddingTop: 14,
        marginTop: 2,
        color: "var(--text-dim)",
      }}
    >
      <nav aria-label="Legal" style={{ display: "flex", flexWrap: "wrap", gap: "10px 18px" }}>
        <a href={PRIVACY_URL} style={linkStyle}>
          Privacy Policy
        </a>
        <a href={TERMS_URL} style={linkStyle}>
          Ticket Holder Agreement
        </a>
      </nav>
      <p style={{ margin: "10px 0 0", maxWidth: 1000, fontSize: 10, lineHeight: 1.55 }}>
        To submit a copyright infringement notice, contact Legend Sports Cave at{" "}
        <a href="mailto:legal@legendsportscave.com" style={{ color: "inherit" }}>
          legal@legendsportscave.com
        </a>{" "}
        with the subject line &lsquo;DMCA Notice.&rsquo; Please include the information required under 17 U.S.C.
        § 512(c)(3).
      </p>
    </div>
  );
}

const linkStyle: React.CSSProperties = {
  color: "var(--text-muted)",
  fontFamily: "var(--font-mono)",
  fontSize: 10,
  fontWeight: 700,
  letterSpacing: "var(--ls-label)",
  textTransform: "uppercase",
  textUnderlineOffset: 4,
};
